import { createIcon } from '@/utils/factoryUtil'

export const SVGCommonSalt = createIcon('SVGCommonSalt', (props) => (
  <svg viewBox='0 0 100 100' {...props}>
    <path d='M13.36,45.97L45.97,13.36l30.57,39.31-23.88,23.88L13.36,45.97ZM37.24,4.62L4.62,37.24C-.63,42.49-.1,51.16,5.77,55.72l48.07,37.39c11.14,8.65,27,7.67,36.97-2.31s10.96-25.84,2.31-36.97L55.72,5.77C51.16-.1,42.49-.63,37.24,4.62ZM84.26,84.26c-1.21,1.21-3.16,1.21-4.37,0s-1.21-3.16,0-4.37,3.16-1.21,4.37,0,1.21,3.16,0,4.37ZM86.44,68.97c1.21,1.21,1.21,3.16,0,4.37s-3.16,1.21-4.37,0-1.21-3.16,0-4.37,3.16-1.21,4.37,0ZM73.34,86.44c-1.21,1.21-3.16,1.21-4.37,0s-1.21-3.16,0-4.37,3.16-1.21,4.37,0,1.21,3.16,0,4.37Z' />
  </svg>
))
